import { browserName, osName } from 'react-device-detect'

/** Consent copy shown on the lead-form signature step (docs listed below the pad). Sent for audit. */
export const LEAD_SIGNATURE_CONSENT_DISPLAY =
    'I confirm that I have read and understood the documents below'
export const LEAD_SIGNATURE_CONSENT_SUPPORTING =
    'and authorise Sentinel Legal to apply my signature to them and pursue my hearing loss claim on my behalf.'

export type LeadSignaturePayload = {
    sigData: string
    browser: string
    device: string
    consent: {
        checked: true
        displayName: string
        supportingText: string
    }
}

export const buildLeadSignaturePayload = (sigData: string, consentChecked: boolean): LeadSignaturePayload | null => {
    if (!sigData || !consentChecked) return null
    return {
        sigData,
        browser: browserName,
        device: osName,
        consent: {
            checked: true,
            displayName: LEAD_SIGNATURE_CONSENT_DISPLAY,
            supportingText: LEAD_SIGNATURE_CONSENT_SUPPORTING,
        },
    }
}
